import React from 'react';
import { Label } from '../../types/labels';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import LabelChip from '../StarLabels/LabelChip';

export default function PartsLabelDisplay({
	labels = [],
	className = '',
	darkMode = false,
}: {
	labels: Label[];
	className?: string;
	darkMode?: boolean;
}) {
	if (nullSafeGet('length', labels) < 1) {
		return null;
	}

	return (
		<div className={`flex flex-row flex-wrap items-center gap-3 ${className}`}>
			{labels.map((tag) => (
				<LabelChip label={tag} key={tag.id} onDark={darkMode} />
			))}
		</div>
	);
}
